export default {
      id: "partitions-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#partitions",
      toString: function () {
        return this.url;
      }
    }